import fetchApi from '@/lib/tools/api'
import {Producer, ProducerStore} from '@/types'
import {Box, Button} from '@mui/material'
import React, {useCallback} from 'react'
import {RaRecord, useListContext, useNotify, useRecordContext, useRefresh, useUnselectAll} from 'react-admin'

interface UnlinkUsersResponse {
	success: boolean
	unlinkedCount: number
	producer?: Producer
	store?: ProducerStore
}

interface LinkedUsersBulkActionsProps {
	resourceToUpdate?: string
}

export default function LinkedUsersBulkActions({resourceToUpdate = 'producers'}: LinkedUsersBulkActionsProps) {

	const {selectedIds} = useListContext()
	const record = useRecordContext<RaRecord>()
	const unselectAll = useUnselectAll(`${resourceToUpdate}.${record.id}.producers/users`)
	const refresh = useRefresh()
	const notify = useNotify()

	const unlink = useCallback(async () => {
		try {
			const response = await fetchApi<UnlinkUsersResponse>(
				`/${resourceToUpdate}/${record.id}/unlink-users`,
				{userIds: selectedIds},
				null,
				'POST'
			)

			if (response.success) {
				unselectAll()
				refresh()
				notify(`${response.unlinkedCount} utilisateur(s) délié(s) avec succès`, {type: 'success'})
			}
		} catch (error) {
			notify('Erreur lors de la déliaison des utilisateurs', {type: 'error'})
			console.error(error)
		}
	}, [selectedIds, record.id, resourceToUpdate, unselectAll, refresh, notify])

	return (
		<Box>
			<Button onClick={unlink} variant="contained" color="error">Délier la sélection</Button>
		</Box>
	)
}
